<template>
  <div class="container">
    <div class="categories">
      <ul>
        <li
          v-for="category in categories"
          :key="category.id"
          :class="{ active: category.id === selectedCategoryId }"
          @click="selectCategory(category.id)"
        >
          {{ category.name }}
        </li>
      </ul>
    </div>
    <div class="products">

      <div class="grid_goods" v-if="products.length>0">
        <div class="goods_box" v-for="(product,index) in products" :key="product.id"
        @click="addToCart(product)">
          <img class="goods_img" :src="product.picture_src" />
          <div class="goods_price">￥{{ product.price }}</div>
        </div>
      </div>
      <div v-else class="text-center">
        <img class="nogoods" src="../assets/nogoods.png"/>
        <div>此分类暂无商品</div>
      </div>
    </div>
    <div class="nav-container">
      <div class="nav-item" v-for="item in menuItems" :key="item.label" @click="footerChange(item)">
        <img :src="item.icon"></img>
        <div class="label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getHomeGoods
  } from "../utils/api"
export default {
  data() {
    return {
      categories: [
        { id: 1, name: '红酒' },
        { id: 2, name: '工艺品' },
        { id: 3, name: '收藏品' },
        { id: 4, name: '白酒' },
        // 其他分类...
      ],
      menuItems: [{
          icon: require('../assets/homes.png'),
          label: '首页'
        },
        {
          icon: require('../assets/slitem.png'),
          label: '分类'
        },
        {
          icon: require('../assets/my.png'),
          label: '我的'
        }
      ],
      products: [],
      products: [],
      page: 1,
      selectedCategoryId: 1,
      touchBottom: false,
    };
  },
  computed: {
    filteredProducts() {
      return this.products.filter(
        product => product.categoryId === this.selectedCategoryId
      );
    },
  },
  created() {
    this.getGoodsList(); //获取商品列表
  },
  methods: {
    footerChange(item){
      switch (item.label){
        case "我的":
          this.$router.push({
            name: 'my',
          })
          break;
        case "首页":
          this.$router.push({
            name: 'shopIndex',
          })
          break;
      }
      console.log(item,"sss")
    },
    addToCart(product) {
      this.$router.push({
        name: 'shopping',
        query: {
          code_id: product.landing_page_info_code,
          clickid:'2024'
        }
      })
      // 这里可以添加更多的逻辑，比如更新购物车显示、保存购物车状态等
    },
    selectCategory(categoryId) {
      this.page = categoryId;;
      this.selectedCategoryId = categoryId;
      this.getGoodsList()
    },
    getGoodsList() {
      getHomeGoods({
        page: this.page
      }).then(res => {
        this.products =res.data;

      })
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
}

.categories {
  width: 150px;
  overflow-y: auto;
  height: 100vh;
  border-right: 1px solid #ccc;
}

.categories ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.categories li {
  padding: 10px;
  cursor: pointer;
}

.categories li.active {
  background-color: #f0f0f0;
  font-weight: bold;
}

.products {
  flex: 1;
  padding: 10px;
}

.products ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.products li {
  padding: 10px 0;
}
.grid_goods{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}
.goods_img{
  width: 100%;
  max-height: 120px;
}
.goods_price{
  color: #ff2744;
  font-weight: bold;
}
.nogoods{
  width: 150px;
}
.text-center{
  text-align: center;
}
.nav-container {
    display: flex;
    justify-content: space-around;
    background-color: #f8f9fa;
    padding: 10px 0;
    border-top: 1px solid #ccc;
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .nav-item {
    text-align: center;
    flex-grow: 1;

  }

  .nav-item img {
    width: 25px;
    height: 25px;
  }

  .icon {
    display: block;
    font-size: 24px;
    color: #333;
  }

  .label {
    font-size: 12px;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/components/itemize.vue